import { useQuery } from '@tanstack/react-query';
import { AGREEMENT_KEY } from '../../utils/constants/queryKeys';
import { getAgreementById } from '../services/fn-api/Agreements';

export const useGetAgreement = (id: number) => {
  return useQuery({
    queryKey: [AGREEMENT_KEY, id],
    queryFn: () => getAgreementById(id),
    retry: false,
    enabled: !!id,
  });
};
